import { style, styleVariants } from "@vanilla-extract/css";

import { vars } from "~/styles/tokens.css";

// Horizontal flex row that wraps when it runs out of space. Classic
// "Cluster" pattern from Every Layout — ideal for toolbars, button
// groups, tag lists, and anywhere you want "n things in a row, wrap
// at the viewport edge."
const base = style({
  display: "flex",
  flexWrap: "wrap",
});

export const clusterGap = styleVariants({
  none: [base, { gap: vars.space.none }],
  xs: [base, { gap: vars.space.xs }],
  sm: [base, { gap: vars.space.sm }],
  md: [base, { gap: vars.space.md }],
  lg: [base, { gap: vars.space.lg }],
  xl: [base, { gap: vars.space.xl }],
});

export const clusterAlign = styleVariants({
  start: { alignItems: "flex-start" },
  center: { alignItems: "center" },
  end: { alignItems: "flex-end" },
  baseline: { alignItems: "baseline" },
});

export const clusterJustify = styleVariants({
  start: { justifyContent: "flex-start" },
  center: { justifyContent: "center" },
  end: { justifyContent: "flex-end" },
  between: { justifyContent: "space-between" },
});
